import '../../index.css';
var styles = {
  "interactiveIcon": "bp_interactive_icon_module_interactiveIcon--dc5ee"
};
export { styles as default };